import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >
                <DataColumn kid='column1' name='Codice Fiscale' fieldName='fiscalcode' minWidth={120} maxWidth={120} align='center' />
                <DataColumn kid='column2' name='Cognome' fieldName='lastname' minWidth={120} maxWidth={170} align='center' />
                <DataColumn kid='column3' name='Nome' fieldName='firstname' minWidth={150} align='center' />
            </DataList>
        </>
    );
}
